<template>
  <div class="box-shadow">
    <!-- <div class="" style="display:flow-root;" v-if="can_access('stock','upload')">
    <a href="javascript:;" class="pull-right" @click="showModal('upload-deal-ticket-out')" v-if="can_access('stock','upload')">Upload Deal Ticket CSV</a>
  </div> --> 
  <form>
    <div class="col-sm-12">
      <div class="row">
        <div class="col-sm-4 form-group">
          <label>Security Type</label>
          <select name="type" class="form-control" v-model="formInput.type">
            <option value="equity" selected>Equity</option>
            <option value="non-equity">Non Equity</option>
          </select>
        </div>    
      </div>
      <div class="row">  
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.tidm')}">
          <label>Ticker(TIDM)</label><span class="message">{{ validation.firstError('formInput.tidm') }}</span>
          <vue-bootstrap-typeahead
                ref="tidm"
                :data="instruments"
                v-model="formInput.tidm"
                :serializer="InstrumentFormattedDisplay"
                placeholder="Search Ticker"
                @hit="setInstrumentInfo"
              />
          <!--<input type="text" placeholder="Enter TIDM Here.." class="form-control" v-model="formInput.tidm">-->
        </div>
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.exchange_name')}">
          <label>Exchange Name</label><span class="message">{{ validation.firstError('formInput.exchange_name') }}</span>
          <input type="text" placeholder="Enter Exchange Name Here.." class="form-control" v-model="formInput.exchange_name">
        </div>  
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.issuer_name')}">
          <label>Instrument/Security Name</label><span class="message">{{ validation.firstError('formInput.issuer_name') }}</span>
          <input type="text" placeholder="Enter Instrument Name Here.." class="form-control" v-model="formInput.issuer_name">
        </div>
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.isin')}">
          <label>ISIN</label><span class="message">{{ validation.firstError('formInput.isin') }}</span>
          <input type="text" placeholder="Enter ISIN Here.." class="form-control" v-model="formInput.isin">
        </div> 
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.sedol')}">
          <label>SEDOL</label><span class="message">{{ validation.firstError('formInput.sedol') }}</span>
          <input type="email" placeholder="Enter SEDOL Here.." class="form-control" v-model="formInput.sedol">
        </div>
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.cusip')}">
          <label>CUSIP</label><span class="message">{{ validation.firstError('formInput.cusip') }}</span>
          <input type="text" placeholder="Enter CUSIP Here.." class="form-control" v-model="formInput.cusip">
        </div>
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.stamp_duty_exemption_start_date')}">
          <label>Stamp Duty Exemption Start Date (DD-MM-YYYY)</label><span class="message">{{ validation.firstError('formInput.stamp_duty_exemption_start_date') }}</span><br>
          <date-picker input-class="form-control" ref="stamp_duty_exemption_start_date" type="date" v-model="formInput.stamp_duty_exemption_start_date" value-type="format" format='DD-MM-YYYY'></date-picker>
        </div>   
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.stamp_duty_exemption_end_date')}">
          <label>Stamp Duty Exemption End Date (DD-MM-YYYY)</label><span class="message">{{ validation.firstError('formInput.stamp_duty_exemption_end_date') }}</span><br>
          <date-picker input-class="form-control" ref="stamp_duty_exemption_end_date" type="date" v-model="formInput.stamp_duty_exemption_end_date" value-type="format" format='DD-MM-YYYY'></date-picker>
        </div>   
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.currency')}">
          <label>Currency</label><span class="message">{{ validation.firstError('formInput.currency') }}</span>
          <input type="text" placeholder="Enter Currency Here.." class="form-control" v-model="formInput.currency">
        </div>  
      </div>
      
      <input type="hidden" v-model="formInput.id"/>
      <div class="" style="display:flow-root">
        <button type="button" v-on:click="addSecurities" class="pull-right btn btn-lg btn-info">Submit</button>     
      </div>  
         
    </div>
  </form>
  <b-modal ref="upload-deal-ticket-out" title="Upload Deal Ticket" size="xl" hide-footer v-if="can_access('stock','upload')">
    <p class="my-4"><UploadDealTicketForm :forceRerender="uploadDealTicketFormReRender" uri="import_stocks"/></p>
  </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import common from '@/assets/js/common.js';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import SimpleVueValidator from 'simple-vue-validator';
import UploadDealTicketForm from '@/components/Accounts/UploadTradesCSV';

const Validator = SimpleVueValidator.Validator;
export default {
  name: 'AddSecurityForm',
  props:['forceRerender','rows'],
  components: { DatePicker,VueBootstrapTypeahead,UploadDealTicketForm },
  mixins: [common,SimpleVueValidator.mixin],
  data(){
    return {
      showDetailedForm: false,
      lessOrMore: "more",
      securities: [],
      instruments: [],
      group: {},
      formInput:{
        'id' : '',
        'type' : 'equity',
        'tidm' : '',
        'exchange_name' : '',
        'issuer_name' : '',
        'isin': '',
        'sedol' : '',
        'cusip' : '',
        'stamp_duty_exemption_start_date' : '',
        'stamp_duty_exemption_end_date' : '',
        'currency' : '',
        'status': 1,
      }
    };
  },
  validators: {
    'formInput.tidm': function(value) {
      return Validator.value(value).required();
    },
    'formInput.exchange_name': function(value) {
      return Validator.value(value);
    },
    'formInput.issuer_name': function(value) {
      return Validator.value(value);
    },
    'formInput.isin': function(value) {
      return Validator.value(value).required();
    },
    'formInput.sedol': function(value) {
      return Validator.value(value).required();
    },
    'formInput.cusip': function(value) {
      return Validator.value(value);
    },
    'formInput.stamp_duty_exemption_start_date': function(value) {
      return Validator.value(value).regex('^((0[1-9]|[12]\\d|3[01])-(0[1-9]|1[0-2])-([12]\\d{3}))$', 'Not in Valid Format: DD-MM-YYYY.');
    },
    'formInput.stamp_duty_exemption_end_date': function(value) {
      return Validator.value(value).regex('^((0[1-9]|[12]\\d|3[01])-(0[1-9]|1[0-2])-([12]\\d{3}))$', 'Not in Valid Format: DD-MM-YYYY.');
    },
    'formInput.currency': function(value) {
      return Validator.value(value).required();
    },
  },
  watch: {
    'formInput.tidm': function (input) {
      this.$refs.tidm.inputValue = input;
      this.group={};
      //this.formInput.id = '';
      this.getInstrumentByTicker(input);
    },
    'formInput.id': function(){
      if(this.formInput.status == 0) this.addSecurities();
    },
  },
  methods: {
    addSecurities: function(){
      this.$validate()
          .then(async (success) => {
            if (success) {
              const {response} = await this.call_axios('add_stocks', 'post', this.formInput);
              this.forceRerender(response);
            }
          });
    },
    async getInstrumentByTicker (input) {
      const limit = 10, offset = 0, sort = '', order = '';
      var filter = {}; 
      filter['tidm'] = input;
      var uri = 'stock_list?limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter);
      const {response} = await this.call_axios(uri);
      this.instruments = response.data.result;
    },
    setInstrumentInfo (group) {
      if(typeof group == "object"){console.log(group);
        this.group = group;
        Object.assign(this.formInput, group);
      }
    },
    InstrumentFormattedDisplay (result) {
      return result.tidm;
    },
    setShowDetailedForm: function(e){
      e.preventDefault();
      this.showDetailedForm = this.showDetailedForm?false:true;
      this.lessOrMore = this.showDetailedForm?"less":"more";
    },
    showModal(model) {
      this.$refs[model].show()
    },
    uploadDealTicketFormReRender(reaponse){
      if(response.code==0){
          this.$refs['upload-deal-ticket-out'].hide()
          this.$toasted.success("Successfully Added",{duration:1000});
      }
    },
  },
  mounted(){
  },
  created(){
    if(typeof this.rows != 'undefined'){
      Object.assign(this.formInput, this.rows);
    }
  }
};
</script>

<style lang="scss" scoped>
.mx-datepicker{
  width: 100%;
}
.heading{
  font-weight:600;
}
.error .message{
  padding: 0px 5px;
  color: red;
} 
</style>